/**
 * This class is responsible for managing the state of the sticky video player.
 * It keeps track of the currently active sticky player and provides methods
 * to set, get, and clear the active sticky player ID.
 * When the active sticky player changes, it dispatches a custom event
 * to notify other parts of the application.
 *
 * Usage:
 * const stickyController = new StickyController();
 * stickyController.setActiveSticky("player1");
 * const activePlayerId = stickyController.getActiveSticky();
 * stickyController.clear("player1");
 */
class StickyController {
  private activeStickyId: string | null = null;

  setActiveSticky(id: string) {
    this.activeStickyId = id;

    window.dispatchEvent(
      new CustomEvent("stickyPlayerChanged", {
        detail: { playerId: id },
      }),
    );
  }

  getActiveSticky() {
    return this.activeStickyId;
  }

  clear(id: string) {
    if (this.activeStickyId === id) {
      this.activeStickyId = null;
    }
  }
}

export default new StickyController();
